# Configuring Audio

## Configuring Audio

You must first configure audio inputs and cross-points in Ventuz for this section to work correctly

## Frame Audio

It is often useful to be able to mute the audio of all but one frames to avoid mulitple asset audio from overlapping.

You can achieve this by adjusting the volume of each frame in the Frame Audio Controls Selection

## Input Audio

Inputs (such as SDI) have individual audio controls that can be adjusted in the Input Audio Controls Selection
